<template>
	<vs-prompt
		:active.sync="activePrompt"
		:title="$t('changeStatusTaskTitle')"
		@accept="accept"
		@cancel="cancel"
		:acceptText="$t('yes')"
		:cancelText="$t('cancel')"
		color="primary"
	>
		<div>
			{{ $t('doYouWantCompletedTask') }}
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ModalCompletedTask",
	props: {
		active: {
			required: true,
			type: Boolean
		},
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept");
		},
		cancel() {
			this.activePrompt = false;
			this.$emit("cancel");
		},
	}
};
</script>

<style>

</style>